<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2"><a id="page_vii"></a><a id="ack"></a>ACKNOWLEDGMENTS</h2>
<p class="noindent">The editors would like to acknowledge the assistance, support, and encouragement provided during the process of developing this manuscript. All the contributors are due special thanks for their patience and willingness to see the project through to completion. Special thanks to Merold Westphal for encouraging us to pursue the project, to Martha Nussbaum for supporting our efforts from the beginning of the project, and to the editors at Indiana University Press, Dee Mortensen and Jane Lyle, who provided guidance, encouragement, and assistance along the way.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// acknowledgments.vue?41064598